import { registerContext } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { WorkoutInfoForm } from './views/WorkoutInfoForm';
import {
  EditWorkoutVM,
  useEditWorkoutVM,
  UseEditWorkoutVMParams,
} from './view-models/workoutEdit.viewModel';
import { TemplateSelection } from './components/TemplateSelection';
import { workoutTypeFromLocation } from '@client/paths';
import { Header } from './components/Header';
import { WorkoutTemplates } from './views/WorkoutTemplates';
import { WorkoutClipboard } from './components/WorkoutClipboard/WorkoutClipboard';
import { AddTemplatesFromLibraryModal } from './components/addFromLibrary/addTemplatesFromLibraryModal';
import { SingleExercisePublishModal } from './components/SingleExercisePublishModal';
import { ExerciseTypesInfoModal } from './components/ExerciseTypesModal';
import { UnsavedChangesModal } from './components/UnsavedChangesModal';
import { AutoplayedSettingsModal } from '../workout-editor/view/components/common/AutoplayedSettingsModal';
import { useWorkoutVM } from '../workout-editor/view-model/workout.viewModel';
import { RoutingProvider } from '@client/new/hooks/useRouting';
import { InjectedRouter, PlainRoute } from '@client/router/compat';

export const workoutVM = registerContext('workoutVM', useWorkoutVM);

export const legacyEditWorkoutVM = registerContext(
  'legacyEditWorkoutVM',
  useEditWorkoutVM,
);

const EditWorkout = (data: EditWorkoutVM) => {
  return (
    <workoutVM.ValueProvider
      params={'0'}
      renderer={() => (
        <div className="flex flex-col p-6 gap-4 scroll-smooth">
          <WorkoutClipboard
            onOpen={() => data.dispatch('openClipboard')}
            paste={data.addFromClipboard}
            disabledPaste={data.workoutType === 'class'}
          />
          <Header
            dispatch={data.dispatch}
            control={data.control}
            currentBreadcrumb={data.currentBreadcrumb}
            watch={data.watch}
            isNewForm={data.isNewForm}
            workoutId={data.workoutId}
            isSaving={data.isSaving}
            submitting={data.submitting}
            publishAction={data.publishAction}
            readonly={data.readonly}
            errorMessage={data.errorMessage}
            newWorkoutErrors={data.newWorkoutErrors}
          />
          <WorkoutInfoForm {...data} />
          <TemplateSelection
            templates={data.templateSelection}
            control={data.control}
            disabled={data.readonly}
            observedId={data.workoutInfoId}
            dispatch={data.dispatch}
          />
          <WorkoutTemplates {...data} />
          <AddTemplatesFromLibraryModal {...data.addTemplateFromLibrary} />
          <SingleExercisePublishModal {...data.singleExercisePublishModal} />
          <ExerciseTypesInfoModal {...data.exerciseTypesInfoModal} />
          <UnsavedChangesModal {...data.unsavedChangesModal} />
          <AutoplayedSettingsModal />
        </div>
      )}
    />
  );
};

export const EditWorkoutPage = (p: {
  location: { pathname: string; query: Record<string, string> };
  routeParams: { influencerId: number; id: number };
  router: InjectedRouter;
  route: PlainRoute;
}) => {
  const params: UseEditWorkoutVMParams = {
    influencerId: Number(p.routeParams.influencerId),
    workoutType: workoutTypeFromLocation(location.pathname),
    workoutId: Number(p.routeParams.id),
    locationQuery: p.location.query,
  };
  return (
    <RoutingProvider routing={{ router: p.router, route: p.route }}>
      <legacyEditWorkoutVM.ValueProvider
        params={params}
        renderer={EditWorkout}
      />
    </RoutingProvider>
  );
};
